import React from 'react'; // eslint-disable-line

const BackArrow = () => {
    return (
        <svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M.62 7.53L7.55.6l1.32 1.32-5.61 5.61 5.61 5.61-1.32 1.32z" fill="#2A2A2A" fillRule="evenodd" /></svg>
    );
};

export default BackArrow;
